module.exports = __webpack_public_path__ + "assets/fonts/house-1.bfd44bc0.svg";